import { setConfirmEndExam, setJobDetailModal, setSelectedJob } from '../../../../../store/workspace/slice';
import { endExamThunk, getJobsThunk } from '../../../../../store/workspace/thunks';
import { selectSelectedJob } from '../../../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../../../store/store';
import { setNotification } from '../../../../../store/general/slice';
import { TrashSquareIcon } from '../../../../../assets/icons';
import CheckBox from '../../../../../components/CheckBox';
import Input from '../../../../../components/Input';
import Modal from '../../../../../components/Modal';
import { useState } from 'react';
import styles from './style.module.scss';

const OTHER_REASON_ID = 3;

const REASONS = [
    { id: 1, text: 'I’ve already hired.' },
    { id: 2, text: 'I’ve completed my project.' },
    { id: OTHER_REASON_ID, text: 'Other' },
];

type Reason = typeof REASONS[number];

export default function ConfirmEndExam() {
    const dispatch = useDispatch();
    const job = useSelector(selectSelectedJob);
    const [comment, setComment] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedReason, setSelectedReason] = useState<Reason | null>(null);

    const closeModal = () => dispatch(setConfirmEndExam(false));

    const endExam = () => {
        if (!job) return;

        setLoading(true);
        dispatch(endExamThunk({
            id: job.id,
            action: 'end',
            reason: selectedReason?.id === OTHER_REASON_ID ? comment : (selectedReason?.text || ''),
        }))
            .unwrap()
            .then(() => {
                dispatch(getJobsThunk({}));
                dispatch(setSelectedJob(null));
                dispatch(setConfirmEndExam(false));
                dispatch(setJobDetailModal(false));
                dispatch(setNotification(['Job ended successfully', 'success']));
            })
            .catch(() => {
                dispatch(setNotification(['Something went wrong,Try again...', 'error']));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Modal
            size='sm'
            actions='both'
            title='End job post'
            closeFunc={closeModal}
            icon={<TrashSquareIcon />}
            dismissButton={{
                text: 'Keep it',
                type: 'Outline-Dark',
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'End it',
                type: 'Error',
                loading: loading,
                onClick: endExam,
                disabled: !selectedReason || (selectedReason.id === OTHER_REASON_ID && !comment),
            }}
        >
            <div className={styles.wrapper}>
                <span className={styles.title}>
                    If you confirm end job post, no interviews
                    or tests will be available for applicants.
                </span>
                <div className={styles.reason}>
                    <span>Please select reason for Stop sharing job post:</span>
                    <div className={styles.reason_list}>
                        {REASONS.map(reason => <CheckBox
                            key={reason.id}
                            text={reason.text}
                            checked={selectedReason?.id === reason.id}
                            onClick={() => setSelectedReason(reason)}
                        />)}
                        {selectedReason?.id === OTHER_REASON_ID && <Input
                            type='text'
                            value={comment}
                            onChange={setComment}
                            placeholder='please specify'
                        />}
                    </div>
                </div>
            </div>
        </Modal>
    );
};
